import { useKeycloak } from '@react-keycloak/web';
import { UserRoles } from '../enums/userRoles';

interface Roles {
  isManager: boolean;
  isTalent: boolean;
  isAdmin: boolean;
  isCompanyManager: boolean;
}

export const useUserRoles = (): Roles => {
  const { keycloak } = useKeycloak();

  const isAdmin = keycloak.tokenParsed?.roles.includes(UserRoles.ADMIN);
  const isCompanyManager = keycloak.tokenParsed?.roles.includes(
    UserRoles.COMPANY_MANAGER
  );
  const isManager = keycloak.tokenParsed?.roles.includes(UserRoles.MANAGER);
  const isTalent = keycloak.tokenParsed?.roles.includes(UserRoles.TALENT);

  return { isManager, isTalent, isCompanyManager, isAdmin };
};
